export class authModel {
    username: string;
    password: string;
    rememberMe: boolean;
    captchaText: string;
    id: number;
}
export class User {
    roleCode: string;
    otp: string;
    userName: string;
}
export class forgotUserNameModel {
    username: string;
    captchaText: string;
    id: number;
}